/**
 * View Components are used to add functionality to views defined in the api.
 * These can be looked for elsewhere, and the appropriate logic activated to deal with whatever functionality
 * the component adds.
 *
 * An example of view components might be a map stat filter, which post-filters all data in the map
 * so that things are only displayed or coloured by if they match the filter.
 */

import { BaseViewController } from '../../BaseViewController';
import { StatFilterFn } from '../../value_getters/value_getter';

/**
 * This function returns a filter function generated from the view's stat_display_filter view component.
 * The returned function filters an array of stats by the filter_queries specified in any
 * view components that are of type stat_display_filter
 * @param {BaseViewController} viewController
 */
export function getStatDisplayFilterFunction(viewController: BaseViewController): StatFilterFn {
    // Handle any extra component filters that are defined on the view
    const statDisplayFilters = viewController.getStatDisplayFilters();

    let filterFunction = null;

    if (statDisplayFilters.length) {
        try {
            const processedFilterFuncQueries = [];
            for (const statDisplayFilter of statDisplayFilters) {
                // The filter makes sure that the stat type matches the table
                if (statDisplayFilter.table && statDisplayFilter.filter_expression) {
                    processedFilterFuncQueries.push(
                        `(stat.imsType !== "${statDisplayFilter.table}" || (${statDisplayFilter.filter_expression}))`,
                    );
                }
            }

            const combinedFiltersString = processedFilterFuncQueries.join(' && ');
            filterFunction = new Function('stat', `return ${combinedFiltersString}`);
        } catch (e) {
            // Log the error, but don't break everything
            console.error(`Error processing view components:`, statDisplayFilters);
            console.error(e);
        }
    }

    // The function that applies the above filters
    return filterFunction;
}
